import React, { useEffect, useState } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_ENDPOINTS } from '../utils/constants';

const Redeem = () => {
  const navigate = useNavigate();
  const [enteredCode, setEnteredCode] = useState('');

  const [promocode, setPromocode] = useState([]);

  const goto = path => {
    navigate(path);
  };
  const fetchPromocode = async () => {
    const token = localStorage.getItem('tringAuthToken');

    if (!token) {
      navigate('/login');
      return;
    }

    try {
      const response = await fetch(API_ENDPOINTS.PROMO_CODE, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch promocodes');
      }

      const data = await response.json();
      setPromocode(data);
      console.log('Promocodes fetched:', data);
    } catch (err) {
      console.error('Error fetching promocodes:', err);
    }
  };
  useEffect(() => {
    fetchPromocode();
  }, []);

  const handleApply = async () => {
    const code = enteredCode.trim().toUpperCase();
    console.log(code);

    if (code === '') {
      toast.error('Please enter a promo code.');
      return;
    }

    const token = localStorage.getItem('tringAuthToken');

    if (!token) {
      navigate('/login');
      return;
    }

    try {
      const response = await fetch(API_ENDPOINTS.PROMO_CODE, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code: code }), // ← correct key and value
      });

      if (!response.ok) {
        throw new Error('Failed to claim promo code');
      }

      fetchPromocode();

      toast.success('Promo code applied successfully!');
      setEnteredCode('');
    } catch (err) {
      console.error('Error applying promo:', err);
      toast.error('Something went wrong while applying the promo code.');
      setEnteredCode('');
    }
  };

  const handleClaim = async id => {
    try {
      const token = localStorage.getItem('tringAuthToken');

      if (!token) {
        navigate('/login');
        return;
      }

      const response = await fetch(API_ENDPOINTS.PROMO_CODE, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ promoId: id }),
      });

      if (!response.ok) throw new Error('Failed to claim promo code');

      fetchPromocode();
      toast.success('Promo code claimed successfully!');
      setEnteredCode('');
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="px-3 d-flex flex-column" style={{ minHeight: '100dvh' }}>
      <ToastContainer position="top-center" autoClose={3000} />
      <div className="d-flex align-items-center my-3">
        <IoIosArrowBack size={24} onClick={() => goto('/main')} />
        <h5 className="mb-0 ms-2 ">Apply Promo Code</h5>
      </div>

      <div className="d-flex mb-3">
        <input
          type="text"
          className="form-control me-2"
          placeholder="Enter Coupon Code"
          value={enteredCode}
          onChange={e => setEnteredCode(e.target.value)}
        />
        <button
          className="btn px-4 text-white"
          style={{
            background:
              'linear-gradient(90deg, rgb(207, 20, 28) 0%, rgb(133, 55, 101) 100%)',
            border: 'none',
          }}
          onClick={handleApply}
        >
          Apply
        </button>
      </div>

      <h5 className="mb-0 p-2 text-start">Available Coupon</h5>

      {/* Coupon Card Template */}
      {promocode.map((promo, index) => (
        <div
          key={index}
          className="border rounded p-3 mb-3 bg-white"
          style={{ boxShadow: '0 0 8px rgba(0,0,0,0.05)' }}
        >
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="mb-0 " style={{ textAlign: 'left' }}>
              {promo.code}
            </h6>

            <button
              style={{
                background:
                  'linear-gradient(90deg, rgb(207, 20, 28) 0%, rgb(133, 55, 101) 100%)',
                border: 'none',
              }}
              className={`btn btn-sm px-4 ${promo.isEligible ? 'btn-secondary' : 'btn-danger'}`}
              disabled={!promo.isEligible}
              onClick={() => handleClaim(promo.id)}
            >
              {!promo.isEligible ? 'Claimed' : 'Claim'}
            </button>
          </div>
          {/* <hr style={{ borderTop: "2px dashed" }} /> */}
          {/* Description with line breaks */}
          <p className="mb-0 text-muted " style={{ textAlign: 'left' }}>
            {promo.description.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>
      ))}
    </div>
  );
};

export default Redeem;
